// Hardcoded prices, extracted equivalences from Magento
const currencies = [
    { symbol: 'EUR', value: 1 },
    { symbol: 'GBP', value: 0.9 },
    { symbol: 'CHF', value: 1 },
    { symbol: 'PLN', value: 5 },
    { symbol: 'RON', value: 5 },
    { symbol: 'AED', value: 4.5 },
];
const computePrices = (prices) => prices.map(priceItem => {
    const currencyObject = {};
    currencies.forEach(currency => {
        currencyObject[currency.symbol] = {
            maximum_price: {
                final_price: {
                    currency: currency.symbol,
                    value: priceItem.maxFinal * currency.value,
                },
                regular_price: {
                    currency: currency.symbol,
                    value: priceItem.maxRegular * currency.value,
                },
            },
            minimum_price: {
                final_price: {
                    currency: currency.symbol,
                    value: priceItem.minFinal * currency.value,
                },
                regular_price: {
                    currency: currency.symbol,
                    value: priceItem.minRegular * currency.value,
                },
            },
        };
    });
    return currencyObject;
});
const computedWithDiscount = (prices, isPromoActive) => prices.map(price => {
    let maxDiscount = 0;
    let minDiscount = 0;
    if (isPromoActive) {
        if (price.isPercentage) {
            maxDiscount = price.maxRegular * price.discount;
            minDiscount = price.minRegular * price.discount;
        }
        else {
            maxDiscount = price.discount;
            minDiscount = price.discount;
        }
    }
    return {
        maxFinal: price.maxRegular - maxDiscount,
        maxRegular: price.maxRegular,
        minFinal: price.minRegular - minDiscount,
        minRegular: price.minRegular,
    };
});

export { computePrices, computedWithDiscount };
//# sourceMappingURL=staticPrices.js.map
